import React from "react";
import { connect } from "react-redux";
import { wrapper } from "@/store";
import { actions as mainActions } from "@/bit/reducers/reducers.main-reducer";
import { getStaticProps as getStaticPropsMethod } from "@/utils/page/ssr-pages-handler";
import FichasLayout from "@/layouts-cms/ficha-cms";

class Public extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      breadcrumbsProps,
      headerProps,
      seoInfo,
      footerProps,
      orionInfo,
      orionAlias,
    } = this.props;
    return (
      <FichasLayout
        seoInfo={seoInfo}
        breadcrumbsProps={breadcrumbsProps}
        headerProps={headerProps}
        orionInfo={{ ...orionInfo }}
        orionAlias={orionAlias}
        footerProps={footerProps}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Public);

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const isNotProd = `${process.env.NEXT_PUBLIC_ENV_NAME}` !== "prod";
  const { store } = data;
  const orionAlias = "cms-page-tv-1";
  store.dispatch(mainActions.setOrionAlias(orionAlias));
  const info = await getStaticPropsMethod(data, "ssr-tv", 0, {
    pathname: "/",
    orionProductListCategory: "null",
    orionRules: null,
    orionCmsAlias: orionAlias,
    seoLocation: "www.movistar.es/tv",
    headerLocation: "/tv",
    layout: "ficha",
  });
  const allProps2Return = {
    props: {
      ...info.props,
      orionAlias,
    },
    revalidate: info.revalidate || 300,
  };
  if (isNotProd && allProps2Return.revalidate) {
    delete allProps2Return.revalidate;
  }
  return allProps2Return;
});
